import {curry, CurriedFunction2} from './function'

export const evolve = curry((
  fns: {[key: string]: (...args: any[]) => any},
  obj: {[key: string]: any}
): {[key: string]: any} => {
  const rtn: {[key: string]: any} = {}

  for (const [key, value] of Object.entries(obj)) {
    rtn[key] = typeof fns[key] === 'function'
      ? fns[key](value)
      : value
  }

  return rtn
})

export const isEmpty = (obj: object): boolean =>
  !Object.keys(obj).length

export const filter = curry((
  filter: (value: any, key: string) => boolean,
  obj: {[key: string]: any}
): {[key: string]: any} => {
  const result: {[key: string]: any} = {}

  for (const [key, value] of Object.entries(obj)) {
    if (filter(value, key)) {
      result[key] = value
    }
  }

  return result
})
